import React, { useEffect, useMemo, useState } from 'react';
import {
  Box,
  Button,
  Card,
  CardHeader,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  LinearProgress,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField
} from '@mui/material';
import axios from 'src/utils/axios';
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import SaveIcon from '@mui/icons-material/Save';
import UndoIcon from '@mui/icons-material/Undo';
import AlertAndLoading from 'src/components/AlertAndLoading';
import {
  ORANGE,
  darkButtonSx,
  dialogPaperProps,
  inputSx,
  lightButtonSx,
  useDynamicStyles
} from 'src/components/dynamicCatalogStyles';
import DynamicListToolbar, { filterDynamicRows } from 'src/components/DynamicListToolbar';

// Ara durumun hangi ana durumda görüneceği (SetStatusList'e giden status değeri)
const STATUS_COLUMNS = [
  { field: 'COZUM_MERKEZI', label: 'Çözüm Merkezi', status: 23 },
  { field: 'DEGISIM_OFISI', label: 'Değişim Ofisi', status: 14 }
];

const switchSx = {
  '& .MuiSwitch-switchBase.Mui-checked': { color: ORANGE },
  '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': { backgroundColor: ORANGE }
};

const changeKey = (subStatus, status) => `${subStatus}-${status}`;

function SetStatus() {
  const classes = useDynamicStyles();
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [aradurumlar, setaradurumlar] = useState([]);
  // Kaydedilmemiş değişiklikler: { 'araDurumId-status': { value, substatus, status } }
  const [changes, setChanges] = useState({});
  const [newsubstatus, setnewsubstatus] = useState(false);
  const [cozummerkezivale, setcozummerkezivalue] = useState(false);
  const [degisimofisivale, setdegisimofisivale] = useState(false);
  const [aradurumadivalue, setaradurumadivalue] = useState("");
  const [searchText, setSearchText] = useState('');
  const [responseMessage, setresponseMessage] = useState('');
  const [uyari, setUyari] = useState(false);
  const [alertType, setAlertType] = useState({ ErrorType: 'error', ErrorTitle: 'Uyarı' });

  function InfoAlert(ErrorDescription, ErrorType, ErrorTitle) {
    setresponseMessage(ErrorDescription);
    setAlertType({ ErrorType: ErrorType, ErrorTitle: ErrorTitle });
    setUyari(true);
  }

  const getAraDurum = () => {
    setLoading(true);
    axios.get("/GetStatusList", {
    }).then(response => {
      setaradurumlar(Array.isArray(response.data) ? response.data : []);
      setChanges({});
      setLoading(false);
    }).catch(() => {
      setLoading(false);
    });
  }

  useEffect(() => {
    getAraDurum();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const isChecked = (item, col) => {
    const pending = changes[changeKey(item.ARA_DURUM_ID, col.status)];
    return pending ? pending.value === 1 : !!item[col.field];
  };

  const setDurum = (checked, item, col) => {
    const key = changeKey(item.ARA_DURUM_ID, col.status);
    setChanges((prev) => {
      const next = { ...prev };
      // Orijinal değere dönüldüyse bekleyen değişiklik kalmaz
      if (checked === !!item[col.field]) {
        delete next[key];
      } else {
        next[key] = { value: checked ? 1 : 0, substatus: item.ARA_DURUM_ID, status: col.status };
      }
      return next;
    });
  };

  const changeCount = Object.keys(changes).length;

  const Kaydet = () => {
    const durumlist = Object.values(changes);
    if (durumlist.length === 0) return;
    setSaving(true);
    Promise.all(durumlist.map((durum) =>
      axios.post('SetStatusList', durum, {
        headers: { 'Content-Type': 'application/json' }
      })
    )).then(() => {
      setSaving(false);
      InfoAlert('Değişiklikler kaydedildi.', 'success', 'Başarılı');
      getAraDurum();
    }).catch(() => {
      setSaving(false);
      InfoAlert('Değişiklikler kaydedilirken hata oluştu.', 'error', 'Hata');
      getAraDurum();
    });
  }

  const closenewsubstatus = () => {
    if (saving) return;
    setnewsubstatus(false);
    setcozummerkezivalue(false);
    setdegisimofisivale(false);
    setaradurumadivalue("");
  }

  const ekle = () => {
    const durum = {
      aciklama: aradurumadivalue,
      cozummerkezi: cozummerkezivale ? 1 : 0,
      degisimofisi: degisimofisivale ? 1 : 0
    };
    setSaving(true);
    axios.post('InsertToStatusList', durum, {
      headers: { 'Content-Type': 'application/json' }
    }).then(response => {
      setSaving(false);
      const ok = response.data?.ErrorCode === '0';
      InfoAlert(response.data?.ErrorDescription, ok ? 'success' : 'error', ok ? 'Başarılı' : 'Hata');
      if (ok) {
        setnewsubstatus(false);
        setcozummerkezivalue(false);
        setdegisimofisivale(false);
        setaradurumadivalue("");
        getAraDurum();
      }
    }).catch(() => {
      setSaving(false);
      InfoAlert('Ara durum eklenirken hata oluştu.', 'error', 'Hata');
    });
  }

  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') return;
    setUyari(false);
  };

  const filteredRows = useMemo(() => filterDynamicRows(aradurumlar, {
    searchText,
    searchFields: ['ACIKLAMA']
  }), [aradurumlar, searchText]);

  return (
    <>
      <AlertAndLoading Message={responseMessage} open={uyari} AlertType={alertType} onClose={uyariKapat} />
      <Card className={classes.card}>
        <CardHeader
          className={classes.cardHeader}
          title="Ara Durumlar"
          subheader={loading ? 'Yükleniyor…' : `${aradurumlar.length} ara durum`}
          action={
            <Button startIcon={<AddIcon />} sx={darkButtonSx} onClick={() => setnewsubstatus(true)}>
              Yeni Ara Durum
            </Button>
          }
        />
        {(loading || saving) && <LinearProgress sx={{ height: 2, '& .MuiLinearProgress-bar': { backgroundColor: ORANGE }, backgroundColor: '#ffe0b2' }} />}
        <DynamicListToolbar
          searchText={searchText}
          onSearchChange={setSearchText}
          placeholder="Ara durum ara"
          shownCount={filteredRows.length}
        />
        <TableContainer sx={{ maxHeight: 520, opacity: saving ? 0.6 : 1, pointerEvents: saving ? 'none' : 'auto' }}>
          <Table stickyHeader size="small" className={classes.table}>
            <TableHead>
              <TableRow>
                <TableCell>Ara Durum</TableCell>
                {STATUS_COLUMNS.map((col) => (
                  <TableCell key={col.field} align="center" sx={{ width: 160 }}>{col.label}</TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredRows.map((item) => {
                const rowChanged = STATUS_COLUMNS.some((col) => changes[changeKey(item.ARA_DURUM_ID, col.status)]);
                return (
                  <TableRow key={item.ARA_DURUM_ID} sx={rowChanged ? { backgroundColor: '#fff8e1' } : undefined}>
                    <TableCell sx={{ fontWeight: 600 }}>{item.ACIKLAMA}</TableCell>
                    {STATUS_COLUMNS.map((col) => (
                      <TableCell key={col.field} align="center">
                        <Switch
                          size="small"
                          sx={switchSx}
                          checked={isChecked(item, col)}
                          onChange={(e) => setDurum(e.target.checked, item, col)}
                        />
                      </TableCell>
                    ))}
                  </TableRow>
                );
              })}
              {!loading && filteredRows.length === 0 && (
                <TableRow>
                  <TableCell colSpan={3} className={classes.emptyState}>
                    {aradurumlar.length === 0 ? 'Kayıtlı ara durum bulunamadı.' : 'Aramaya uygun kayıt bulunamadı.'}
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, p: '10px 16px', borderTop: '1px solid #e0e0e0', backgroundColor: '#fafafa' }}>
          <Box sx={{ fontSize: '12px', color: changeCount ? '#e65100' : '#90a4ae', fontWeight: changeCount ? 600 : 400 }}>
            {changeCount ? `${changeCount} kaydedilmemiş değişiklik` : 'Değişiklik yok'}
          </Box>
          <Box sx={{ ml: 'auto', display: 'flex', gap: 1 }}>
            <Button sx={lightButtonSx} startIcon={<UndoIcon />} disabled={!changeCount || saving} onClick={() => setChanges({})}>
              Geri Al
            </Button>
            <Button
              sx={{ ...darkButtonSx, minWidth: 110 }}
              startIcon={saving ? <CircularProgress size={14} sx={{ color: ORANGE }} /> : <SaveIcon />}
              disabled={!changeCount || saving}
              onClick={Kaydet}
            >
              Kaydet
            </Button>
          </Box>
        </Box>
      </Card>

      <Dialog open={newsubstatus} onClose={closenewsubstatus} fullWidth maxWidth="sm" PaperProps={dialogPaperProps}>
        <DialogTitle className={classes.dialogTitle}>
          Yeni Ara Durum
          <IconButton size="small" onClick={closenewsubstatus} disabled={saving}>
            <CloseIcon fontSize="small" />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ pt: '16px !important', opacity: saving ? 0.6 : 1, pointerEvents: saving ? 'none' : 'auto', transition: 'opacity 0.2s' }}>
          <TextField
            fullWidth
            autoFocus
            label="Ara Durum Adı"
            size="small"
            sx={inputSx}
            value={aradurumadivalue}
            onChange={(e) => setaradurumadivalue(e.target.value)}
          />
          <Box className={classes.dialogSection} sx={{ mt: 2 }}>
            <div className={classes.sectionLabel}>Durumlar</div>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 3 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', fontSize: '13px', fontWeight: 600 }}>
                <Switch size="small" sx={switchSx} checked={cozummerkezivale} onChange={(e) => setcozummerkezivalue(e.target.checked)} />
                Çözüm Merkezi
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', fontSize: '13px', fontWeight: 600 }}>
                <Switch size="small" sx={switchSx} checked={degisimofisivale} onChange={(e) => setdegisimofisivale(e.target.checked)} />
                Değişim Ofisi
              </Box>
            </Box>
          </Box>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2.5 }}>
          <Button sx={lightButtonSx} onClick={closenewsubstatus} disabled={saving}>Vazgeç</Button>
          <Button
            sx={{ ...darkButtonSx, minWidth: 110 }}
            onClick={ekle}
            disabled={saving || !aradurumadivalue.trim()}
            startIcon={saving ? <CircularProgress size={14} sx={{ color: ORANGE }} /> : null}
          >
            Ekle
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default SetStatus;
